<div *ngIf="!isEmpty && !isPrestation" class="header">
  <div class="col-sm-7" style="padding: 0 15px;">
    <h2 *ngIf="materiel.id">
      {{!materiel.cede ? 'Modification' : 'Visualisation'}} de : {{ materiel.numParc || ''}}{{ materiel.numParc ? '/': ''}}{{ materiel.immatriculation || ''}} </h2>
    <h2 *ngIf="!materiel.id">
      Création d'un materiel
    </h2>
  </div>
  <div class="col-sm-5 text-right" style="padding-right: 0;">
    <button class="btn-header BtnExportXLS uppercase mr-4" id="close" (click)="common.versionImp(materiel)"
    >
    Version Imp
  </button>
    <button class="btn-header uppercase" id="log" *ngIf="materiel.id && materiel.id > 0"
      (click)="common.getLogs(materiel.id, '15', modalService);">
      Log </button>
    <button class="btn-header uppercase" (click)="returnList()" id="close2">
      Fermer </button>
    <button class="btn-header uppercase actionPricipal" id="valide2" (click)="save()">
      Valider </button>
  </div>
</div>
<mat-divider *ngIf="!isEmpty && !isPrestation"></mat-divider>
<div *ngIf="!isEmpty && !isPrestation" class="editMateriel paramsociete article restriction">
  <ngb-tabset (tabChange)="onTabChange($event)">
    <ngb-tab>
      <ng-template ngbTabTitle> Générales </ng-template>
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 0;" [ngClass]="{'disabledbutton': materiel.cede}">
          <div class="group1" style="padding-top: 10px;">

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Icône :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px"
                [ngClass]="{'disabledbutton': materiel.checkBoxLogo}">
                <app-autocomplete [placeholder]="''" (selectfunction)="materiel.nomIcon = $event.libelle"
                  [results]="listIcon" [highlight]="false" [label]="''" [isFixedHTML]="true" [disablefocus]="true"
                  [dropdownclass]="'dropdownIconMateriel'" [id]="'modedepaie nomIconMateriel'"
                  [htmlCode]="materiel.nomIcon ? listIcon[0].libelleObjetEntite : ''" [isCombo]="true">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Icône personnalisé :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="materiel.checkBoxLogo"></mat-checkbox>
                <div class="col-sm-11 champ text-underline historique pull-right" style="padding: 0"
                  [ngClass]="{'disabledbutton': !materiel.checkBoxLogo}" (click)="openLogo()">
                  Définir
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Immatriculation du matériel :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.immatriculation" [disabled]="isParametrageCamionHolding" >
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Numéro du parc :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.numParc" [disabled]="isParametrageCamionHolding">
                <!--if societe.numParcCamionObligatoire => obligatoire -->
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Type de matériel :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete
                  (selectfunction)="materiel.type = $event; materiel.sousTypeCamion = {}; searchSousTypeMateriel($event.id);"
                  [results]="listTypeMateriel" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                  [disablefocus]="true" [defaultselected]="materiel.type"
                  [defaultsearch]="materiel.type ? materiel.type.libelle : ''">
                </app-autocomplete>
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Sous type de matériel :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.sousTypeCamion = $event;" [results]="listSousTypeMateriel"
                  [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="materiel.sousTypeCamion"
                  [disablefocus]="true"
                  [defaultsearch]="materiel.sousTypeCamion ? materiel.sousTypeCamion.libelle : ''"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Matériel visible sur le planning ecobennes :
                <!-- Benne amovible : -->
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="materiel.isMultiBenne"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Remorque :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="materiel.remorque"></mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Collecte Sélective :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <!-- <mat-checkbox class="example-margin" color="primary" [(ngModel)]="materiel.collecteSelective">
                </mat-checkbox> -->
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="materiel.collecteCollective">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">Année fab. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.anneeFabrication">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">Tare (kg) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.tar">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Contenant :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.typeContenant = $event;" [results]="typeContenant"
                  [disablefocus]="true" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                  [defaultselected]="materiel.typeContenant"
                  [defaultsearch]="materiel.typeContenant ? materiel.typeContenant.libelleObjetEntite : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Prestations associées :</label>
              <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px"
                (click)="showPrestAssociees()">
                Définir
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date d'entrée :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.dateEntree">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date cession :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input *ngIf="materiel.cede" type="text" class="form-control" [(ngModel)]="materiel.dateCession">
                <input *ngIf="!materiel.cede" type="text" class="form-control" value="Véhicule non cédé" readonly>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Motif :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input *ngIf="materiel.cede" type="text" class="form-control" [(ngModel)]="materiel.motifCession">
                <input *ngIf="!materiel.cede" type="text" class="form-control" value="Véhicule non cédé" readonly>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Code Analytique :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.codeAnalytique">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Code analytique Achat :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.codeAnalytiqueAchat">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Fichier :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <div class="btn-group" dropdown style="width: 100%;">
                  <input class="hide" id="input-file-fichier" (change)="getFicheControle($event, row)" multiple
                    type="file"  accept="{{ common.extFichierImgEtTexte }}"  />
                  <button type="button" class="btn btn-default text-left disabledbutton"
                    style="width: calc(100% - 35px); outline: none !important; height: 34px;">
                    {{ materiel.nomFichierFicheControle }}
                  </button>
                  <button id="button-split" type="button" dropdownToggle class="btn btn-default dropdown-toggle-split"
                    aria-controls="dropdown-split" style="outline: none !important"
                    [ngClass]="{'disabledbutton': !materiel.id }">
                    <span class="caret"></span>
                  </button>
                  <ul id="dropdown-split" *dropdownMenu class="dropdown-menu menufichecontrole" role="menu"
                    aria-labelledby="button-split">
                    <li role="menuitem"
                      [ngClass]="{'disabledbutton': !materiel.nomFichierFicheControle || materiel.nomFichierFicheControle === ''}"
                      (click)="openFicheControle()">
                      <a class="dropdown-item"><i class="fa fa-print" aria-hidden="true"></i> Imprimer</a>
                    </li>
                    <!--li role="menuitem"><a class="dropdown-item">Sauvegarder copie</a></li>
                    <li role="menuitem"> <a class="dropdown-item"> Ouvrir </a></li-->
                    <li role="menuitem">
                      <label class="dropdown-item" for="input-file-fichier">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        {{ materiel.nomFichierFicheControle && materiel.nomFichierFicheControle !== '' ? 'Modifier' : 'Ajouter' }}
                      </label>
                    </li>
                    <li role="menuitem"
                      [ngClass]="{'disabledbutton': !materiel.nomFichierFicheControle || materiel.nomFichierFicheControle === ''}"
                      (click)="deleteFicheControle()">
                      <a class="dropdown-item"> <i class="fa fa-trash-o" aria-hidden="true"></i> Supprimer </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Site :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.site = $event;" [results]="listSite" [highlight]="true"
                  [id]="'modedepaie'" [isCombo]="true" [defaultselected]="materiel.site" [disablefocus]="true"
                  [defaultsearch]="materiel.site ? (materiel.site.libelle || materiel.site.nom) : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Km. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.kilometrage">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Marque :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.marque = $event;" [results]="listMarque" [highlight]="true"
                  [id]="'modedepaie'" [isCombo]="true" [defaultselected]="materiel.marque" [disablefocus]="true"
                  [defaultsearch]="materiel.marque ?( materiel.marque.libelleObjetEntite || materiel.marque.nom) : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Type d'équipement :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete
                  (selectfunction)="materiel.typeEquip = $event; materiel.sousTypeEquip = {}; searchSousTypeEquip($event.id)"
                  [results]="listTypeEquip" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                  [defaultselected]="materiel.typeEquip" [disablefocus]="true"
                  [defaultsearch]="materiel.typeEquip ? (materiel.typeEquip.libelle || materiel.typeEquip.libelleObjetEntite) : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">Sous type d'équipement :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.sousTypeEquip = $event;" [results]="listSousTypeEquip"
                  [highlight]="true" [id]="'modedepaie'" [isCombo]="true" [defaultselected]="materiel.sousTypeEquip"
                  [disablefocus]="true"
                  [defaultsearch]="materiel.sousTypeEquip ? (materiel.sousTypeEquip.libelle || materiel.sousTypeEquip.libelleObjetEntite) : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Type de propriété :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.typePropriete = $event;" [results]="listTypePropriete"
                  [disablefocus]="true" [highlight]="true" [id]="'modedepaie'" [isCombo]="true"
                  [defaultselected]="materiel.typePropriete"
                  [defaultsearch]="materiel.typePropriete ? (materiel.typePropriete.libelle || materiel.typePropriete.libelleObjetEntite) : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Durée du loyer :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.dureeLoyer">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Km du Loyer :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.kmLoyer">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Loyer financier :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.loyerFinancier">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Loyer entretien :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.loyerEntretien">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Cession du véhicule :</label>
              <div class="col-sm-9 champ text-underline historique" style="padding: 0 15px"
                (click)="common.openModal(modalService, cession)">
                Céder
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Conso. Moyenne :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.consoMoyenne">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Visible Ecodechet :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox [color]="'primary'" [(ngModel)]="materiel.visibleEcodechet">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                TIPP :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox [color]="'primary'" [(ngModel)]="materiel.TIPP">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Num Badge :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.numBadge">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Remorque :</label>
              <!--Disable if ckecked remorque -->
              <div class="col-sm-9 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': materiel.remorque}">
                <app-autocomplete (selectfunction)="materiel.CamionRemorque = $event;"
                  (searchfunction)="searchRemorque($event)" [results]="listRemorque" [highlight]="true"
                  [id]="'modedepaie'" [defaultselected]="materiel.CamionRemorque" [disablefocus]="true"
                  [selectvalue]="true"
                  [defaultsearch]="materiel.CamionRemorque ? (materiel.CamionRemorque.libelle ||  materiel.CamionRemorque.immatriculation) : ''">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Tournée sans retour sur site :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox [color]="'primary'" [(ngModel)]="materiel.tourneeSansRetourSite">
                </mat-checkbox>
              </div>
            </div>
              
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Code externe :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.codeExterne">
              </div>
            </div>              
          </div>
        </div>
      </ng-template>
    </ngb-tab>
    <ngb-tab title="Entretien" id="tab-entretien">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0; height: 100%" [ngClass]="{'disabledbutton': materiel.cede}">
          <div class="col-sm-12 detail" *ngIf="!isEmpty" style="padding: 0; height: 100%"
            (click)="common.outSide($event)">
            <div class="col-sm-12">
              <div class="col-sm-2" style="padding: 0;">
                <label style="padding-right: 10px;"> Au garage </label>
                <mat-checkbox [color]="'primary'" [(ngModel)]="materiel.auGarage"></mat-checkbox>
              </div>
              <div class="col-sm-10 text-right">
                <label class="col-sm-4 champ" style="padding:0px">
                  Programme entretien :
                </label>
                <div class="col-sm-8 champ" style="padding-right: 0px">
                  <app-autocomplete [placeholder]="''"
                    (selectfunction)="materiel.programmeEntretien = $event; getListPrestAFaire($event)"
                    [results]="listPgmEntretien" [highlight]="true" [label]="''" [dropdownclass]="mindropdown"
                    [id]="'modedepaie clientRefact'" [defaultselected]="materiel.programmeEntretien" [isCombo]="true"
                    [defaultsearch]="materiel.programmeEntretien ? (materiel.programmeEntretien.libelleObjetEntite ||  materiel.programmeEntretien.nom) : ''">
                  </app-autocomplete>
                </div>
              </div>
            </div>
            <div class="col-sm-12 ligneBon liste" style="padding: 10px 0 0; height: calc(100% - 50px);">
              <ngx-datatable style="height: 100%" class="material" [rows]="listEntretien" [columnMode]="'force'"
                [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
                [selected]="selected">
                <ngx-datatable-column prop="typePrestation.description"  [width]="fromEcogar? 500 :''">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="dateDerPrest">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Date der </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <app-input-date [class]="'form-control detailfact'" [model]="row.dateModel"
                      (changefct)="changeDateModel($event, row, 'dateDerPrest')" [disable]="row.mettreReadOnlyDateDerPrest">
                    </app-input-date>
                    <!-- <input type="text" class="input form-control detailfact" [(ngModel)]="row.dateDerPrest"
                      placeholder="31/12/9999" [readonly]="row.mettreReadOnlyDateDerPrest" autocomplete="off"> -->
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="nbMoisEntrePrestation">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Nb mois entre </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control text-right detailfact"
                      [(ngModel)]="row.nbMoisEntrePrestation" placeholder="0" autocomplete="off">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="nbJoursEntrePrestation">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Nb jours entre </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control text-right detailfact"
                      [(ngModel)]="row.nbJoursEntrePrestation" placeholder="0" autocomplete="off">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="kmDerPrest">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Km der </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control text-right detailfact" [(ngModel)]="row.kmDerPrest"
                      placeholder="0" autocomplete="off">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="kmEntrePrestation">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Nb km entre </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control text-right detailfact"
                      [(ngModel)]="row.kmEntrePrestation" placeholder="0" autocomplete="off">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="heureDerPrest">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Der H </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control text-right detailfact" [(ngModel)]="row.heureDerPrest"
                      placeholder="0" autocomplete="off">
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="heureEntrePrestation">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> H entre </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <input type="text" class="input form-control text-right detailfact"
                      [(ngModel)]="row.heureEntrePrestation" placeholder="0" autocomplete="off">
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
    <ngb-tab title="Carte Grise">
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 0;" [ngClass]="{'disabledbutton': materiel.cede}">
          <div class="group1" style="padding-top: 10px;">
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> N° carte grise :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.numeroCarteGrise">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> N° du département :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.numeroDepartement">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Genre national :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.genre = $event.libelleObjetEntite;" [disablefocus]="true"
                  (searchfunction)="changeChampRecherche($event, 'genre')" [results]="listGenre" [highlight]="true"
                  [id]="'modedepaie'" [defaultselected]="materiel.genre" [showonclick]="true"
                  [defaultsearch]="materiel.genre || ''"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> N° d'id :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.numId">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date 1er immat. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.dateImm">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Puissance (CV) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.puissance">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Type var.-version :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.typeVariantVersion">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Carrosserie nat. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.carroserieNat">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Dénom. C/le :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.denominationCle">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Motorisation :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.objMotorisation = $event;materiel.motorisation = $event.libelleObjetEntite;"
                  [disablefocus]="true" [results]="listMotorisation" [highlight]="true" [id]="'modedepaie'"
                  [isCombo]="true"  [defaultselected]="materiel.objMotorisation"
                  [defaultsearch]="materiel.objMotorisation? materiel.objMotorisation.libelleObjetEntite : (materiel.motorisation || 'Aucune' )">
                </app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Couleur :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.couleur = $event.libelleObjetEntite;" [disablefocus]="true"
                  (searchfunction)="changeChampRecherche($event, 'couleur')" [results]="listCouleur" [highlight]="true"
                  [id]="'modedepaie'" [defaultselected]="materiel.couleur" [showonclick]="true"
                  [defaultsearch]="materiel.couleur || ''"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Pays :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.pays">
              </div>
            </div>

            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Catégorie (CE) :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete (selectfunction)="materiel.categorie = $event.libelleObjetEntite;"
                  [disablefocus]="true" (searchfunction)="changeChampRecherche($event, 'categorie')"
                  [results]="listCategorie" [highlight]="true" [id]="'modedepaie'"
                  [defaultselected]="materiel.categorie" [showonclick]="true"
                  [defaultsearch]="materiel.categorie || ''"></app-autocomplete>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Immat. cert. préc. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.immatriculationCertifPrec">
              </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="societe.nomConducteur">
              <label class="col-sm-3 champ" style="padding:0px"> Titulaire :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.titulaireNom">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Adresse titulaire :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.titulaireAdresse1">
                <input type="text" class="form-control" [(ngModel)]="materiel.titulaireAdresse2"
                  style="margin-top: 5px; margin-bottom: 5px;">
                <input type="text" class="form-control" [(ngModel)]="materiel.titulaireAdresse3">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Code Postal titulaire :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete-cp-ville [cp]="'titulaireCodePostal'" [item]="materiel" [ville]="'titulaireVille'"
                  [iscp]="true">
                </app-autocomplete-cp-ville>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Ville titulaire :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete-cp-ville [cp]="'titulaireCodePostal'" [item]="materiel" [ville]="'titulaireVille'">
                </app-autocomplete-cp-ville>
              </div>
            </div>
            <div class="form-group items col-sm-12" *ngIf="societe.nomConducteur">
              <label class="col-sm-3 champ" style="padding:0px"> Utilisateur :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.utilisateurNom">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Adresse utilisateur :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.utilisateurAdresse1">
                <input type="text" class="form-control" [(ngModel)]="materiel.utilisateurAdresse2"
                  style="margin-top: 5px; margin-bottom: 5px;">
                <input type="text" class="form-control" [(ngModel)]="materiel.utilisateurAdresse3">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Code Postal utilisateur :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete-cp-ville [cp]="'utilisateurCodePostal'" [item]="materiel" [ville]="'utilisateurVille'"
                  [iscp]="true">
                </app-autocomplete-cp-ville>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Ville utilisateur :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-autocomplete-cp-ville [cp]="'utilisateurCodePostal'" [item]="materiel"
                  [ville]="'utilisateurVille'"></app-autocomplete-cp-ville>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Le prop. est le tit. :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="materiel.titulaireProprietaire">
                </mat-checkbox>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Nombre titulaires :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.nombreTitulaires">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Code id. du type :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.codeIdentifType">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> PTAC :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.PTAC">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> PTAC2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.PTAC2">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> PTRA :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.PTRA">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Poids vide attélage :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.poidsVideAttelage">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Poids vide :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.poidsVide">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date immatriculation :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px"> 
               <app-input-date [class]="'form-control detailDateIm'" [model]="materiel.dateImmatriculationModel"
                (changefct)="changeDateModel($event, materiel, 'dateImmatriculation')">
              </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Date immat. préc. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <app-input-date [class]="'form-control detailDateIm'" [model]="materiel.dateImmatriculationPrecedenteModel"
                (changefct)="changeDateModel($event, materiel, 'dateImmatriculationPrecedente')">
              </app-input-date>
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Carrosserie (CE) :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.carrosserieCE">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> N° de récep./type :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.numReceptionType">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Cylindrée :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.cylindree">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Puissance max. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.puissanceMax">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Rapport puiss./masse :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.rapportPuissanceMasse">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Place assises :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.placesAssises">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Place debout :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="1" class="form-control" [(ngModel)]="materiel.placesDebout">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Niveau sonore :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.niveauSonore">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Vitesse moteur :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.vitesseMoteur">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> CO2 :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.CO2">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Classe env. :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.classeEnv">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Taxe :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.taxe">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Taxe additionnelle :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="number" step="0.001" class="form-control" [(ngModel)]="materiel.taxeAdditionnelle">
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px"> Taxe totale :</label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control">
                <!--total des 2 taxe-->
              </div>
            </div>
            <div class="form-group items col-sm-12">
              <label class="col-sm-3 champ" style="padding:0px">
                Mentions spéciales :
              </label>
              <div class="col-sm-9 champ" style="padding-right: 0px">
                <input type="text" class="form-control" [(ngModel)]="materiel.mentionsSpeciales">
                <input type="text" class="form-control" [(ngModel)]="materiel.mentionsSpeciales2"
                  style="margin-top: 5px; margin-bottom: 5px;">
                <input type="text" class="form-control" [(ngModel)]="materiel.mentionsSpeciales3">
                <input type="text" class="form-control" [(ngModel)]="materiel.mentionsSpeciales4">
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
    <ngb-tab>
      <ng-template ngbTabTitle>
        <div (click)="getListEquipement()">Equipements</div>
      </ng-template>
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;" [ngClass]="{'disabledbutton': materiel.cede}">
          <div class="col-sm-12 detail" style="padding: 0; height: 100%">
            <div class="col-sm-12 ligneBon liste" style="padding: 0; height: 100%">
              <ngx-datatable style="height: 100%" class="material" [rows]="listEquipement" [columnMode]="'force'"
                [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: loadTable ? 'Chargement ...' : 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadTable" [selected]="selected">
                <ngx-datatable-column prop="typeEquipementCamion.libelle">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Type équipement de matériel </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="numEquipement">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> N° équipement de matériel </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
    <ngb-tab>
      <ng-template ngbTabTitle>
        <div (click)="getListHistoImma()"> Historique Immatriculation </div>
      </ng-template>
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;" [ngClass]="{'disabledbutton': materiel.cede}">
          <div class="col-sm-12 detail" style="height: 100%; padding: 0;">
            <div class="col-sm-12 ligneBon liste" style="height: 100%; padding: 0;">
              <ngx-datatable style="height: 100%" class="material" [rows]="listImmaHisto" [columnMode]="'force'"
                [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: loadTable ? 'Chargement ...' : 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadTable" [selected]="selected">
                <ngx-datatable-column prop="date">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Date </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="immatriculation">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Ancienne immatriculation </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="user">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Utilisateur </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="value">{{ value.nom || '' }} {{ value.prenom || '' }} / {{ value.login || '' }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
    <ngb-tab>
      <ng-template ngbTabTitle>
        <div (click)="getListHistoSite()"> Historique site </div>
      </ng-template>
      <ng-template ngbTabContent>
        <div class="col-sm-12" style="padding: 10px 0 0;" [ngClass]="{'disabledbutton': materiel.cede}">
          <div class="col-sm-12 detail" style="height: 100%; padding: 0;">
            <div class="col-sm-12 ligneBon liste" style="height: 100%; padding: 0;">
              <ngx-datatable style="height: 100%" class="material" [rows]="listSiteHisto" [columnMode]="'force'"
                [headerHeight]="35" (activate)="onActivate($event)" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: loadTable ? 'Chargement ...' : 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadTable" [selected]="selected">
                <ngx-datatable-column prop="date">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Date </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <div *ngIf = "!row.edit">
                      {{ value }}
                    </div>
                    <div class="col-sm-12" *ngIf = "row.edit">
                      <app-input-date  [dateVide]="true" [class]="'form-control input-simple'"
                      [id]="'txtDate'" [model]="row.dateEdit"
                      [closeDatepickerOnSelect]="true"
                      [container]="true" [showDatepicker]="true"
                      (changefct)="changeDateContrat($event, 'dateEdit', row)"></app-input-date>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="site">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Ancien site / ville </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="value">{{ value.nom || '' }} / {{ value.ville || '' }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="user">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                    let-selectFn="selectFn" let-sort="sortFn">
                    <div class="tableheader">
                      <span class="uppercase"> Utilisateur </span>
                    </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="value">{{ value.nom || '' }} {{ value.prenom || '' }} / {{ value.login || '' }}</span>
                  </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column [width]="150" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                [resizeable]="false">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                  <div class="text-right" style="padding-right: 5px;">
                    <button *ngIf="!row.edit" class="btn-detail" (click)="row.edit = !row.edit; showInputDate(rowIndex,row)">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button *ngIf="row.edit" class="btn-detail save" (click)="confirmSaveHistoSite(row)">
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
        
                    <button *ngIf="row.edit" class="btn-detail cancel" (click)="cancel()">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              </ngx-datatable>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-tab>
  </ngb-tabset>
</div>

<div *ngIf="isPrestation" style="height: 100%;">
  <div class="header">
    <div class="col-sm-8" style="padding: 0 15px;">
      <h2> Prestation associées </h2>
    </div>
    <div class="col-sm-4 text-right" style="padding-right: 0;">
      <button class="btn-header uppercase" (click)="showPrestAssociees()" id="close2"> Fermer </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: calc(100% - 50px); padding: 0px"
    (click)="common.outSide($event)">
    <div class="header col-sm-12">
      <div class="col-sm-6">
        <button class="btn-add" id="addLigne" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addLigne()">Ajouter une ligne</span>
      </div>
      <div class="col-sm-6 text-right">
        <h2> Liste des prestations associées </h2>
      </div>
    </div>

    <div class="col-sm-12 ligneBon liste" style="height: calc(100% - 40px);">
      <ngx-datatable style="height: 100%" class="material" [rows]="materiel.prestationAssociees" [columnMode]="'force'"
        [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
        [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
        [selected]="selected">
        <ngx-datatable-column prop="code">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> code </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <app-autocomplete [placeholder]="row.article ? '' : 'Article'" (searchfunction)="searchArticle($event)"
              (selectfunction)="setValue($event, row)" [notOblig]="true" [label]="''" [selectvalue]="true"
              [container]="true" [results]="dataArticle" [id]="classPresta + ' article' + rowIndex"
              [defaultsearch]="value || row.libelle" [autohide]="true" [dropdownclass]="'dropetat'"
              (keyenterfunction)="common.focusNext('.ligneBon')">
            </app-autocomplete>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column prop="libelle">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Libéllé </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{ value }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
          [resizeable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <div class="text-center">
              <button class="btn-detail" (click)="deleteLigne(row);">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>

<ng-template #cession>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Cession du véhicule {{materiel.immatriculation}} : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px"> Date cession :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <app-input-date [class]="'form-control'" [id]="'date'" [model]="dateCession"
            (changefct)="dateCession = $event; changeDate($event, 'dateCession');" [placeholder]="'Date cession'"
            (keyenterfct)="common.changeDate($event, contenant.modelDebut, '#motifCession');" [showDatepicker]="true"
            [closeDatepickerOnSelect]="true">
          </app-input-date>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-3 champ" style="padding:0px"> Motif :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
          <textarea class="form-control" id="motifCession" [(ngModel)]="materiel.motifCession" row="3"></textarea>
        </div>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="save(true)">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler </button>
    </div>
  </div>
</ng-template>

<ng-template #logo>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Définition de logo : </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modalFicheClient" style="height: auto">
    <div class="col-sm-12" style="padding: 0px;">
      <div class="col-sm-12" style="padding: 0 0 15px 15px;">
        <img [src]="cheminLogo" alt="{{ cheminLogo }}" style="max-width: 100%; width: auto; max-height: 300px;" />
      </div>
      <div class="col-sm-8">
        <input class="hide" id="input-file-societe" (change)="getNameFile($event)" type="file"  accept="{{ common.extFichierImg }}" />
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="objFileObject.nom" readonly>
          <label class="input-group-addon" for="input-file-societe"><i class="fa fa-upload"></i> Parcourir
          </label>
        </div>
      </div>

    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="validerLogo();common.closeModal();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();"> Annuler </button>
    </div>
  </div>
</ng-template>


<ng-template #confirmEditDate>
  
  <div class="modal-body" style="height: auto">
    <div>
      Voulez-vous vraiment enregistrer la date ?
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider"  (click)="common.closeModal();saveHistoSite(objSite);">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();objSite.edit = false"> NON</button>
    </div>
  </div>
</ng-template>